if($('footer#footer').length){
    $('#signature').append('<span class="sigantureFirm"> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a></span>')
    $('footer#footer').after($('.footer-bottom'))
    $('footer#footer').before($('footer#footer .customRating'))
    $('footer#footer').before($('footer#footer .CustomInstagram'))    
    $(".instagram-widget>a").each(function(){
        $(".CustomInstagram .igFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
    $(document).ready(function() {
        var storedData = sessionStorage.getItem(document.location.hostname+'-ratingData');
        if (storedData) {
            var ratingData = JSON.parse(storedData);
            displayRatingData(ratingData);
        } else {
            $.ajax({
                url: '/hodnoceni-obchodu/',
                type: 'GET',
                success: function(response) {
                    var content = $(response);
                    var rateAverageInner = parseFloat(content.find('.rate-average-inner .rate-average').html().trim().replace(',', '.'));
                    var rateStarWrapStar = content.find('.rate-star-wrap .stars').html();
                    var rateStarWrapStarsLabel = content.find('.rate-star-wrap .stars-label').html();
                    var percentilRating = Math.floor(100 * parseFloat(rateAverageInner) / 5);
                    var ratingsFinal = content.find('.votes-wrap').html();
    
                    var ratingData = {
                        rateAverageInner: rateAverageInner,
                        rateStarWrapStar: rateStarWrapStar,
                        rateStarWrapStarsLabel: rateStarWrapStarsLabel,
                        percentilRating: percentilRating,
                        ratingsFinal: ratingsFinal
                    };
                    sessionStorage.setItem(document.location.hostname+'-ratingData', JSON.stringify(ratingData));
                    displayRatingData(ratingData);
                },
                error: function(xhr, status, error) {
                    console.error("Error fetching rating data:", status, error);
                }
            });
        }
        function displayRatingData(data) {
            $('.customRatingInner .top .ratingStars').html('<span class="stars">' + data.rateStarWrapStar + '</span>');
            $('.customRatingInner .top .ratingCount').html('<a href="/hodnoceni-obchodu/">' + data.rateStarWrapStarsLabel + '</a>');
            $('.customRatingInner .top .text .percentil').html(data.percentilRating + '%');
            $('.customRatingInner .bottom').html(data.ratingsFinal);
        }
    });
}